// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"CreateOrRenameDocumentFolderPopUp_submitButton__TSOrI"};